/**
 * Super Admin Service
 * 
 * API client for super-admin operations.
 */
import apiClient from './apiClient';

const apiBaseURL = '/superadmin';

interface PromoteResponse {
  ok: boolean;
  user_id: string;
  email: string;
  role: string;
  is_active: boolean;
}

const superadminService = {
  /**
   * Promote a user to super-admin role.
   * Requires a valid super-admin setup token.
   * 
   * @param userId - The UUID of the user to promote
   * @param setupToken - The super-admin setup token from environment
   * @returns Response with promoted user details
   */
  promoteToSuperadmin: async (userId: string, setupToken: string): Promise<PromoteResponse> => {
    const response = await apiClient.post<PromoteResponse>(
      `${apiBaseURL}/promote`,
      { user_id: userId },
      { headers: { 'X-Superadmin-Setup-Token': setupToken } }
    );
    return response.data;
  },
};

export default superadminService;
export type { PromoteResponse };
